// extracted by mini-css-extract-plugin
export default {"announcements":"Z_Qt p-2","announcement":"Z_Qv card my-2","announcement--highlighted":"Z_Qw","announcement__list-item":"Z_Qx py-1","announcement__flag":"Z_Qy"};